<template>
  <div class="about">

    <v-card img="https://d1wgggc35trcty.cloudfront.net/lifertl-home.jpg" class="pa-5">

      <v-card color="rgb(0, 0, 0, 0)" elevation="0" height="25vh"></v-card>

      <v-flex xs12 sm8 offset-sm2>
        <v-autocomplete v-if="isMember" v-model="model" :items="items" :loading="isLoading" :search-input.sync="search"
          hide-details :no-data-text="status" item-value="id" item-text="searchkey" label="Search Library" solo clearable>
          <template slot="item" slot-scope="{ parent, item }">
            <v-list-item-avatar color="light-blue" v-on:click="navigateRoute(item.url)">
              <v-icon v-text="'play_arrow'"></v-icon>
            </v-list-item-avatar>
            <v-list-item-content v-on:click="navigateRoute(item.url)">
              <v-list-item-title v-html="parent.genFilteredText(item.title)">
              </v-list-item-title>
              <v-list-item-subtitle v-text="item.breadcrumbs"></v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-action v-html="parent.genFilteredText(item.author)">
            </v-list-item-action>
          </template>
        </v-autocomplete>

        <v-card color="rgb(0, 0, 0, 0)" elevation="0" height="5vh"></v-card>

        <v-card color="rgb(255, 255, 255, 0.5)">
          <v-card-title class="headline black--text">Welcome, {{ userName }}</v-card-title>
          <v-card-subtitle class="black--text">
            <p><strong>Use the navigation bar at the left to access content</strong></p>
            Please be reminded that your account is strictly non-transferable and not to be shared with any third party.
            <br>
            The materials on Life RTL are strictly not to be copied, redistributed or shared by any means.
          </v-card-subtitle>
          <v-card-actions>
            <v-btn text v-on:click="navigateRoute('/about/terms')">Read Terms & Conditions</v-btn>
          </v-card-actions>
        </v-card>

        <v-card color="rgb(0, 0, 0, 0)" elevation="0" height="5vh"></v-card>

        <span v-if="isMember">
          <v-card class="text-center" color="blue-grey darken-1">
            <v-card-subtitle class="white--text">
              We are progressively adding new content to this portal
            </v-card-subtitle>
          </v-card>
          <v-expansion-panels v-model="panel" accordion>
            <v-expansion-panel>
              <v-expansion-panel-header color="blue-grey lighten-4">
                <div class="text-center">
                  Latest Updates - April 2025
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content class="text-center">
                <br>
                1) Missions Seminar 2024 (
                <router-link to="/category/messagelist/177">Home</router-link> /
                <router-link to="/category/messagelist/178">Videos</router-link>
                )
                <br>
                2) The Multigenerational Church Seminar 2024 (
                <router-link to="/category/messagelist/183">Home</router-link> /
                <router-link to="/category/messagelist/184">Videos</router-link>
                )
                <br>
                3) Refire Not Retire! (2024) (
                <router-link to="/category/messagelist/192">Home</router-link> /
                <router-link to="/category/messagelist/193">Videos</router-link>
                )
                <br>
                4) The Presbytery Seminar 2024 (
                <router-link to="/category/messagelist/190">Home</router-link> /
                <router-link to="/category/messagelist/191">Videos</router-link>
                )
               <br>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </span>
        <span v-else>
          <v-card color="rgb(0, 0, 0, 0)" elevation="0" height="25vh"></v-card>
        </span>

      </v-flex>
      <v-card color="rgb(0, 0, 0, 0)" elevation="0" height="15vh"></v-card>
    </v-card>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "UserHome",
  data: () => ({
    panel: 0,
    isLoading: false,
    items: [],
    model: null,
    search: null,
    status: "Start typing to search...",
  }),
  watch: {
    search(val) {
      val && val !== this.model && this.slowFetch(val);
    },
  },
  computed: {
    userName: function () {
      let userObj = this.$store.getters.getUser;
      let displayName = "";
      if (userObj != null) {
        if (userObj.preferredname != null) {
          displayName = userObj.preferredname;
        }
      }
      return displayName;
    },
    isMember: function () {
      return this.$store.getters.isMember;
    },
  },
  methods: {
    navigateRoute: function (newpath) {
      this.$router.push(newpath, () => { });
    },
    slowFetch(v) {
      this.isLoading = true;
      clearTimeout(this._timerId);
      this._timerId = setTimeout(() => {
        this.fetch(v);
      }, 500);
    },
    fetch(v) {
      axios
        .get("https://awsapi.lifertl.com/search/" + v)
        .then((res) => {
          this.items = [];
          this.items = res.data;
          this.status = "No results";
        })
        .catch((err) => {
          this.status = "Search is currently unavailable";
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
};
</script>
